import 'isomorphic-fetch';

import { ApolloClient as BaseApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';

import { GRAPHQL_URL, GRAPHQL_URL_REMOTE } from '@lib/const';

import type { NormalizedCacheObject } from '@apollo/client';

const uri = !process.browser ? GRAPHQL_URL_REMOTE : GRAPHQL_URL;

export type InitialState = { initialState?: NormalizedCacheObject };

export function createApolloClient({ initialState }: InitialState = {}): ApolloClient {
  const httpLink = createHttpLink({
    uri,
    credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
  });

  const cache = new InMemoryCache();

  if (initialState) cache.restore(initialState);

  return new BaseApolloClient({
    connectToDevTools: process.browser && process.env.NODE_ENV === 'development',
    ssrMode: !process.browser, // Disables forceFetch on the server (so queries are only run once)
    link: httpLink,
    cache,
  });
}

export type ApolloClient = BaseApolloClient<NormalizedCacheObject>;
